import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import messages from './messages'
import { useQueryExternalBankAccounts } from '../../models/useQueryExternalBankAccounts'

export const useGetExternalBankAccountsPresenter = ({
  params,
  enabled = true,
}: {
  params?: RepoFilterParams
  enabled?: boolean
} = {}) => {
  const intl = useProcurifyIntl()

  const { externalBankAccounts, isFetching } = useQueryExternalBankAccounts({
    params,
    enabled,
    onError: () => {
      toast.error({
        title: intl.formatMessage(
          messages.fetchingExternalBankAccountsToastError
        ),
      })
    },
  })

  return {
    data: {
      externalBankAccounts,
    },
    states: {
      isFetching,
    },
  }
}
